import { PropsWithChildren, useReducer } from 'react';
import { AlarmsContext, alarmsReducer, AlarmsReducerDefaultValues } from './AlarmsContext';
import { GraphContext, graphReducer, GraphReducerDefaultValues } from './GraphContext';
import { HistoryContext, historyReducer, HistoryReducerDefaultValues } from './HistoryContext';
import { SharedContext, sharedReducer, SharedReducerDefaultValues } from './SharedContext';
import { SiteListContext, siteListReducer, SiteListReducerDefaultValues } from './SiteListContext';

export const ContextProviderComponent: React.FC<PropsWithChildren> = ({ children }) => {
  const [sharedState, sharedDispatch] = useReducer(sharedReducer, SharedReducerDefaultValues);

  const [graphState, graphDispatch] = useReducer(graphReducer, GraphReducerDefaultValues);

  const [historyState, historyDispatch] = useReducer(historyReducer, HistoryReducerDefaultValues);

  const [alarmsState, alarmsDispatch] = useReducer(alarmsReducer, AlarmsReducerDefaultValues);

  const [siteListState, siteListDispatch] = useReducer(siteListReducer, SiteListReducerDefaultValues);

  return (
    <SiteListContext.Provider value={{ state: siteListState, dispatch: siteListDispatch }}>
      <SharedContext.Provider value={{ state: sharedState, dispatch: sharedDispatch }}>
        <GraphContext.Provider value={{ state: graphState, dispatch: graphDispatch }}>
          <HistoryContext.Provider value={{ state: historyState, dispatch: historyDispatch }}>
            <AlarmsContext.Provider value={{ state: alarmsState, dispatch: alarmsDispatch }}>
              {children}
            </AlarmsContext.Provider>
          </HistoryContext.Provider>
        </GraphContext.Provider>
      </SharedContext.Provider>
    </SiteListContext.Provider>
  );
};
